import { Action } from 'redux';

import { ISpaceTypeInfo } from '~src/ts/models/resourceInfoParts';

import { SpaceInfo, SpaceType, SubspaceName } from '../../state/SpaceInfo';
import { EnterContentSpaceAction,EnterSpace,SetSpaceInfoItem } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface EnterSpaceAction extends Action, SpaceInfo {}

export function enterSpace(spaceInfo: SpaceInfo): EnterSpaceAction {
  return {
    type: EnterSpace,
    ...spaceInfo
  };
}

export const isEnterSpaceAction = isActionFactory<EnterSpaceAction>(EnterSpace);

export interface SetSpaceInfoItemAction extends Action, SpaceInfo {}

export function setSpaceInfoItem(spaceInfo: SpaceInfo): SetSpaceInfoItemAction {
  return {
    type: SetSpaceInfoItem,
    ...spaceInfo
  };
}

export const isSetSpaceInfoItemAction = isActionFactory<SetSpaceInfoItemAction>(SetSpaceInfoItem);

export interface ContentSpaceInfo {
  contentLocation: string;
  item: ISpaceTypeInfo;
  spaceType: SpaceType;
  subspaceName: SubspaceName;
  ownerId: string;
}

export interface EnterContentSpaceAction extends Action {
  contentSpaceInfo: ContentSpaceInfo;
}


// This enter space action is to be utlized in the scenario of content detail pages 
// where the content could have a parent container(location) such as Personal Space
export function enterContentSpace(result: ContentSpaceInfo): EnterContentSpaceAction {
  return {
    type: EnterContentSpaceAction,
    contentSpaceInfo: result
  };
}
